exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-input__error {\n  color: #cf4931;\n  font-family: 'Calibre-Regular', Arial, sans-serif;\n}\n", ""]);

// exports
